<template>
    <v-container fluid class="fill-height welcome-page">
        <v-row align="center" justify="center" class="fill-height">
            <v-col cols="12" sm="10" md="8" lg="6">
                <v-card elevation="12" rounded="xl" class="welcome-card">
                    <v-card-title class="text-center pa-8">
                        <div class="d-flex flex-column align-center">
                            <v-img src="/logo.png" max-width="120" class="mb-6" alt="Logo Recruitment App"></v-img>
                            <h1 class="text-h3 mb-4 font-weight-bold">Recruitment App</h1>
                            <p class="text-h6 text-grey-darken-1 text-center">
                                Plateforme de recrutement moderne et intuitive
                            </p>
                        </div>
                    </v-card-title>

                    <v-card-text class="pa-8">
                        <v-row class="mb-6">
                            <v-col cols="12" md="6">
                                <v-card class="candidate-card h-100" elevation="4" rounded="lg"
                                    @click="goToCandidateSpace" hover>
                                    <v-card-text class="text-center pa-6">
                                        <v-icon size="80" color="green" class="mb-4">mdi-account-search</v-icon>
                                        <h2 class="text-h5 mb-3">Espace Candidat</h2>
                                        <p class="text-body-1 mb-4">
                                            Postulez en ligne et suivez l'évolution de vos candidatures
                                        </p>
                                        <v-list class="candidate-features" lines="one">
                                            <v-list-item>
                                                <template v-slot:prepend>
                                                    <v-icon color="green">mdi-check-circle</v-icon>
                                                </template>
                                                <v-list-item-title>Candidature en ligne</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <template v-slot:prepend>
                                                    <v-icon color="green">mdi-check-circle</v-icon>
                                                </template>
                                                <v-list-item-title>Suivi en temps réel</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <template v-slot:prepend>
                                                    <v-icon color="green">mdi-check-circle</v-icon>
                                                </template>
                                                <v-list-item-title>Aucun compte requis</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                    <v-card-actions class="pa-6 pt-0">
                                        <v-btn color="green" variant="elevated" size="large" block>
                                            <v-icon start>mdi-account-plus</v-icon>
                                            Accéder à l'espace candidat
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-card class="employee-card h-100" elevation="4" rounded="lg"
                                    @click="goToEmployeeSpace" hover>
                                    <v-card-text class="text-center pa-6">
                                        <v-icon size="80" color="blue" class="mb-4">mdi-office-building</v-icon>
                                        <h2 class="text-h5 mb-3">Espace Employé</h2>
                                        <p class="text-body-1 mb-4">
                                            Gestion des recrutements et administration
                                        </p>
                                        <v-list class="employee-features" lines="one">
                                            <v-list-item>
                                                <template v-slot:prepend>
                                                    <v-icon color="blue">mdi-check-circle</v-icon>
                                                </template>
                                                <v-list-item-title>Gestion des candidatures</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <template v-slot:prepend>
                                                    <v-icon color="blue">mdi-check-circle</v-icon>
                                                </template>
                                                <v-list-item-title>Dashboard RH</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <template v-slot:prepend>
                                                    <v-icon color="blue">mdi-check-circle</v-icon>
                                                </template>
                                                <v-list-item-title>Outils d'administration</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                    <v-card-actions class="pa-6 pt-0">
                                        <v-btn color="blue" variant="elevated" size="large" block>
                                            <v-icon start>mdi-login</v-icon>
                                            Accéder à l'espace employé
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>

                        <v-divider class="my-6"></v-divider>

                        <div class="text-center">
                            <p class="text-body-2 text-grey-darken-1 mb-4">
                                Choisissez l'espace qui correspond à votre profil
                            </p>
                            <v-chip-group class="justify-center">
                                <v-chip color="green" variant="outlined">
                                    <v-icon start>mdi-account</v-icon>
                                    Candidats
                                </v-chip>
                                <v-chip color="blue" variant="outlined">
                                    <v-icon start>mdi-account-tie</v-icon>
                                    RH
                                </v-chip>
                                <v-chip color="purple" variant="outlined">
                                    <v-icon start>mdi-shield-account</v-icon>
                                    Administrateurs
                                </v-chip>
                            </v-chip-group>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
const goToCandidateSpace = () => {
    // Redirection vers l'espace candidat (même application)
    window.location.href = '/?mode=candidate'
}

const goToEmployeeSpace = () => {
    // Redirection vers l'espace RH/Admin (même application)
    window.location.href = '/?mode=hr'
}
</script>

<style scoped>
.welcome-page {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 100vh;
}

.welcome-card {
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.95);
}

.candidate-card,
.employee-card {
    cursor: pointer;
    transition: all 0.3s ease;
    height: 100%;
}

.candidate-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(76, 175, 80, 0.3);
}

.employee-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(25, 118, 210, 0.3);
}

.candidate-features,
.employee-features {
    background: transparent;
}

.v-list-item {
    padding-left: 0;
    padding-right: 0;
    min-height: 40px;
}

.v-chip-group {
    gap: 8px;
}
</style>
